import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StripeMetaDataFragment = { __typename?: 'StripeMetadataEntity', plan_name?: string | null, taxaroo_plus?: string | null, has_roo_access?: string | null, custom_plan?: string | null };

export type GetCustomDomainUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomDomainUserQuery = { __typename?: 'Query', CustomDomainUser?: { __typename?: 'CustomDomainsEntity', id: string, name: string, certificateArn?: string | null, cloudfrontIdId?: string | null, status?: Types.CustomDomainStatuses | null, firmAccountId?: string | null } | null };

export type CustomDomainCertificateStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomDomainCertificateStatusQuery = { __typename?: 'Query', CustomDomainCertificateStatus: { __typename?: 'CertificateStatusEntity', id: string, Status?: Types.CustomDomainStatuses | null, FailureReason?: Types.FailureReason | null, DomainValidationOptions?: { __typename?: 'DomainValidationOptions', name: string, type: string, value: string } | null } };

export type CustomDomainCnameStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomDomainCnameStatusQuery = { __typename?: 'Query', CustomDomainCnameStatus: { __typename?: 'CnameStatusEntity', hostname: string, cnameStatus: string, distribution: { __typename?: 'DistributionSummaryEntity', Id: string, ARN: string, Status: string, DomainName: string, Aliases: { __typename?: 'AliasesEntity', Items: Array<string>, Quantity: number } } } };

export type IsDomainLiveQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;


export type IsDomainLiveQuery = { __typename?: 'Query', IsDomainLive: boolean };

export type GetCloudFrontDistributionByCertificateArnQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCloudFrontDistributionByCertificateArnQuery = { __typename?: 'Query', GetCloudFrontDistributionByCertificateArn: { __typename?: 'DistributionSummaryEntity', Id: string, ARN: string, Status: string, DomainName: string, Aliases: { __typename?: 'AliasesEntity', Items: Array<string>, Quantity: number } } };

export type GetCustomLayoutsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomLayoutsQuery = { __typename?: 'Query', CustomLayout?: { __typename?: 'CustomLayoutEntity', id: string, firmAccountId?: string | null, headerBackgroundColor?: string | null, headerFontColor?: string | null, logo?: string | null, pixelCode?: string | null } | null };

export type GetUserInformationQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetUserInformationQuery = { __typename?: 'Query', UserInformation: { __typename?: 'UserInformationEntity', firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } };

export type GetSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', GetSubscriptionByContext: { __typename?: 'StripeSubscriptionEntity', id?: string | null, object?: string | null, application_fee_percent?: number | null, billing_cycle_anchor?: number | null, cancel_at?: number | null, cancel_at_period_end?: boolean | null, canceled_at?: number | null, created?: number | null, current_period_end?: number | null, current_period_start?: number | null, customer?: string | null, days_until_due?: number | null, default_payment_method?: string | null, default_source?: string | null, ended_at?: number | null, livemode?: boolean | null, next_pending_invoice_item_invoice?: number | null, pending_setup_intent?: string | null, schedule?: string | null, start_date?: number | null, status?: string | null, trial_end?: number | null, trial_start?: number | null, quantity?: number | null, items: { __typename?: 'StripeSubscriptionItemsEntity', object?: string | null, data?: Array<{ __typename?: 'StripeSubscriptionItemEntity', id?: string | null, object?: string | null, created?: number | null, billing_thresholds?: { __typename?: 'StripeBillingThresholdsEntity', usage_gte?: number | null } | null, plan?: { __typename?: 'StripePlansInformationEntity', id?: string | null, object?: string | null, active?: boolean | null, amount?: number | null, amount_decimal?: string | null, billing_scheme?: string | null, created?: number | null, currency?: string | null, interval?: string | null, interval_count?: number | null, livemode?: boolean | null, tiers_mode?: string | null, trial_period_days?: number | null, product?: string | null, tiers?: Array<{ __typename?: 'StripeTiersEntity', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null, metadata?: { __typename?: 'StripeMetadataEntity', plan_name?: string | null, taxaroo_plus?: string | null, has_roo_access?: string | null, custom_plan?: string | null } | null } | null }> | null }, metadata?: { __typename?: 'StripeMetadataEntity', plan_name?: string | null, taxaroo_plus?: string | null, has_roo_access?: string | null, custom_plan?: string | null } | null, pause_collection?: { __typename?: 'StripeSubscriptionPauseCollection', behavior: string, resumes_at?: number | null } | null } };

export type GetAllPlansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllPlansQuery = { __typename?: 'Query', GetAllPlans: Array<{ __typename?: 'StripePlansInformationEntity', id?: string | null, active?: boolean | null, amount?: number | null, amount_decimal?: string | null, created?: number | null, currency?: string | null, interval?: string | null, interval_count?: number | null, livemode?: boolean | null, nickname?: string | null, product?: string | null, tiers_mode?: string | null, trial_period_days?: number | null, tiers?: Array<{ __typename?: 'StripeTiersEntity', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null, metadata?: { __typename?: 'StripeMetadataEntity', plan_name?: string | null, taxaroo_plus?: string | null, has_roo_access?: string | null, custom_plan?: string | null } | null }> };

export type GetPlansByProductIdQueryVariables = Types.Exact<{
  productId: Types.Scalars['String'];
}>;


export type GetPlansByProductIdQuery = { __typename?: 'Query', GetPlansByProductId: Array<{ __typename?: 'StripePlansInformationEntity', id?: string | null, active?: boolean | null, amount?: number | null, amount_decimal?: string | null, created?: number | null, currency?: string | null, interval?: string | null, interval_count?: number | null, livemode?: boolean | null, nickname?: string | null, product?: string | null, tiers_mode?: string | null, billing_scheme?: string | null, trial_period_days?: number | null, tiers?: Array<{ __typename?: 'StripeTiersEntity', flat_amount?: number | null, flat_amount_decimal?: string | null, unit_amount?: number | null, unit_amount_decimal?: string | null, up_to?: number | null }> | null, metadata?: { __typename?: 'StripeMetadataEntity', plan_name?: string | null, taxaroo_plus?: string | null, has_roo_access?: string | null, custom_plan?: string | null } | null }> };

export type GetPlanQueryVariables = Types.Exact<{
  planId: Types.Scalars['String'];
}>;


export type GetPlanQuery = { __typename?: 'Query', GetPlan: { __typename?: 'StripePlansInformationEntity', id?: string | null, currency?: string | null, interval?: string | null, tiers_mode?: string | null, product?: string | null } };

export type GetUserUniqueLinkQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetUserUniqueLinkQuery = { __typename?: 'Query', UserById: { __typename?: 'UserEntity', id: string, uniqueLink?: string | null } };

export type GetFirmUniqueLinkQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetFirmUniqueLinkQuery = { __typename?: 'Query', FirmAccountById: { __typename?: 'FirmAccountEntity', id: string, uniqueLink?: string | null } };

export type GetProgressStatusesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProgressStatusesQuery = { __typename?: 'Query', ProgressStatuses: Array<{ __typename?: 'ProgressStatusesEntity', id: string, firmAccountId: string, status: string, underlyingStatus: Types.TaxYearStatus, index: number }> };

export type GetUserFirmAccountByFirmAccountQueryVariables = Types.Exact<{
  firmAccountId: Types.Scalars['String'];
}>;


export type GetUserFirmAccountByFirmAccountQuery = { __typename?: 'Query', UserFirmAccountByFirmAccount: Array<{ __typename?: 'UserFirmAccountEntity', id: string, userId?: string | null, roleId: string, firmAccountId: string }> };

export type GetUserByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', UserById: { __typename?: 'UserEntity', id: string, email?: string | null, uniqueLink?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null, Entity?: { __typename?: 'Entity', id: string } | null } };

export type GetRolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', Roles: Array<{ __typename?: 'RolesEntity', id: string, description: string }> };

export type GetUserFirmAccountByFirmAccountAndFilterQueryVariables = Types.Exact<{
  firmAccountId: Types.Scalars['String'];
  filterDelete: Types.Scalars['Boolean'];
}>;


export type GetUserFirmAccountByFirmAccountAndFilterQuery = { __typename?: 'Query', UserFirmAccountByFirmAccountAndFilter: Array<{ __typename?: 'UserFirmAccountEntity', id: string, roleId: string, firmAccountId: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, deleteAt?: any | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null }> };

export type GenerateOtpQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GenerateOtpQuery = { __typename?: 'Query', generateOTP: { __typename?: 'generateOtpEntity', codeQR: string, key: string } };

export type FirmAccountByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type FirmAccountByIdQuery = { __typename?: 'Query', FirmAccountById: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, type: Types.FirmAccountType, businessType: Types.BusinessType, uniqueLink?: string | null, createAt: any, updateAt: any, deleteAt?: any | null } };

export type GetBusinessInformationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBusinessInformationQuery = { __typename?: 'Query', BusinessInformation: { __typename?: 'BusinessInformationEntity', id?: string | null, taxReturns?: number | null, yearsInBusiness?: number | null, taxPercent?: number | null, accountingPercent?: number | null, bookKeepingPercent?: number | null, payrollPercent?: number | null, taxResolutionPercent?: number | null, other?: number | null, firmAccountId?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, userInformationId?: string | null, businessInformationId?: string | null, createAt: any, updateAt: any, type: Types.PhoneType }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, userInformationId?: string | null, businessInformationId?: string | null, createAt: any, updateAt: any }> | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, type: Types.FirmAccountType, businessType: Types.BusinessType, uniqueLink?: string | null, createAt: any, updateAt: any, deleteAt?: any | null } | null } };

export type GetFirmNotificationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFirmNotificationsQuery = { __typename?: 'Query', getFirmNotifications: { __typename?: 'GroupedFirmNotificationsEntity', TEAM?: Array<{ __typename?: 'FirmNotificationsEntity', id: string, firmAccountId: string, notificationId: string, active: boolean, Notifications?: { __typename?: 'NotificationsEntity', name: string, description?: string | null, type: Types.NotificationType } | null }> | null, CLIENT?: Array<{ __typename?: 'FirmNotificationsEntity', id: string, firmAccountId: string, notificationId: string, active: boolean, Notifications?: { __typename?: 'NotificationsEntity', name: string, description?: string | null, type: Types.NotificationType } | null }> | null, REMINDERS?: Array<{ __typename?: 'FirmNotificationsEntity', id: string, firmAccountId: string, notificationId: string, active: boolean, Notifications?: { __typename?: 'NotificationsEntity', name: string, description?: string | null, type: Types.NotificationType } | null, FirmNotificationReminder?: { __typename?: 'FirmNotificationReminderEntity', id: string, frequency: number, maxReminders: number } | null }> | null } };

export type InvoicesFragment = { __typename?: 'InvoicesEntity', id: string, quantity: number, createAt: any, updateAt: any, priceEach: number, paymentId: string, description: string };

export type PaymentsFragment = { __typename?: 'PaymentsEntity', id: string, taskId?: string | null, createAt?: any | null, updateAt?: any | null, entityId?: string | null, requestAt?: any | null, deletedAt?: any | null, promisedAt?: any | null, completedAt?: any | null, paidOffline?: boolean | null, referralFee?: number | null, preparerFee?: number | null, firmAccountId?: string | null, discountApplied?: number | null, totalDollarAmount?: number | null, taxYearInterviewId?: string | null, paymentProcessorId?: string | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, quantity: number, createAt: any, updateAt: any, priceEach: number, paymentId: string, description: string }> | null };

export type SignatureFieldFragment = { __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldId?: string | null, createAt: any, updateAt: any, fieldType: Types.FieldType, signatureId?: string | null, signerParty?: number | null, fieldTopPercentage?: number | null, fieldLeftPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null };

export type SignatureFragment = { __typename?: 'SignatureEntity', id: string, fileId: string, createAt: any, updateAt: any, fileRequestId: string, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldId?: string | null, createAt: any, updateAt: any, fieldType: Types.FieldType, signatureId?: string | null, signerParty?: number | null, fieldTopPercentage?: number | null, fieldLeftPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null }> | null };

export type FileFragment = { __typename?: 'FileEntity', id: string, name?: string | null, size?: number | null, s3Key?: string | null, pages?: number | null, folder?: string | null, userId?: string | null, createAt: any, updateAt: any, deleteAt?: any | null, uploadedBy: string, documentUsed?: boolean | null, firmAccountId?: string | null, taxYearInterviewId?: string | null, Signatures?: Array<{ __typename?: 'SignatureEntity', id: string, fileId: string, createAt: any, updateAt: any, fileRequestId: string, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldId?: string | null, createAt: any, updateAt: any, fieldType: Types.FieldType, signatureId?: string | null, signerParty?: number | null, fieldTopPercentage?: number | null, fieldLeftPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null }> | null }> | null };

export type KbaFieldsFragment = { __typename?: 'KBAFieldEntity', id: string, type: Types.QuestionType, value?: string | null, KBAId: string, createAt: any, updateAt: any, description?: string | null };

export type KbaFragment = { __typename?: 'KbaEntity', id: string, type: Types.KbaType, createAt: any, updateAt: any, isValidated: boolean, fileApprovalId?: string | null, isIdScanPassed: boolean, isIdScanPending: boolean, numKbaAttempts?: number | null, numFailedIdScans?: number | null, numKbaFailedAttempts?: number | null, numRequestedIdScans?: number | null, KBAFields?: Array<{ __typename?: 'KBAFieldEntity', id: string, type: Types.QuestionType, value?: string | null, KBAId: string, createAt: any, updateAt: any, description?: string | null }> | null };

export type FileApprovalFragment = { __typename?: 'FileApprovalEntity', id: string, expiresAt: any, completedAt?: any | null, fileRequestId: string, email: string, name: string, kbaEnable: boolean, createAt: any, updateAt: any, KBA?: Array<{ __typename?: 'KbaEntity', id: string, type: Types.KbaType, createAt: any, updateAt: any, isValidated: boolean, fileApprovalId?: string | null, isIdScanPassed: boolean, isIdScanPending: boolean, numKbaAttempts?: number | null, numFailedIdScans?: number | null, numKbaFailedAttempts?: number | null, numRequestedIdScans?: number | null, KBAFields?: Array<{ __typename?: 'KBAFieldEntity', id: string, type: Types.QuestionType, value?: string | null, KBAId: string, createAt: any, updateAt: any, description?: string | null }> | null }> | null };

export type FileRequestFragment = { __typename?: 'FileRequestEntity', id: string, title?: string | null, notes?: string | null, userId?: string | null, taskId?: string | null, clientId?: string | null, createAt: any, updateAt: any, compiledHash?: string | null, signedFileId?: string | null, firmAccountId?: string | null, compiledFileId?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, taxYearInterviewId: string, Signatures?: Array<{ __typename?: 'SignatureEntity', id: string, fileId: string, createAt: any, updateAt: any, fileRequestId: string, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldId?: string | null, createAt: any, updateAt: any, fieldType: Types.FieldType, signatureId?: string | null, signerParty?: number | null, fieldTopPercentage?: number | null, fieldLeftPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null }> | null }> | null, CompiledFile?: { __typename?: 'FileEntity', id: string, name?: string | null, size?: number | null, s3Key?: string | null, pages?: number | null, folder?: string | null, userId?: string | null, createAt: any, updateAt: any, deleteAt?: any | null, uploadedBy: string, documentUsed?: boolean | null, firmAccountId?: string | null, taxYearInterviewId?: string | null, Signatures?: Array<{ __typename?: 'SignatureEntity', id: string, fileId: string, createAt: any, updateAt: any, fileRequestId: string, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldId?: string | null, createAt: any, updateAt: any, fieldType: Types.FieldType, signatureId?: string | null, signerParty?: number | null, fieldTopPercentage?: number | null, fieldLeftPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null }> | null }> | null } | null, SignedFile?: { __typename?: 'FileEntity', id: string, name?: string | null, size?: number | null, s3Key?: string | null, pages?: number | null, folder?: string | null, userId?: string | null, createAt: any, updateAt: any, deleteAt?: any | null, uploadedBy: string, documentUsed?: boolean | null, firmAccountId?: string | null, taxYearInterviewId?: string | null, Signatures?: Array<{ __typename?: 'SignatureEntity', id: string, fileId: string, createAt: any, updateAt: any, fileRequestId: string, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldId?: string | null, createAt: any, updateAt: any, fieldType: Types.FieldType, signatureId?: string | null, signerParty?: number | null, fieldTopPercentage?: number | null, fieldLeftPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null }> | null }> | null } | null, FileApprovals?: Array<{ __typename?: 'FileApprovalEntity', id: string, expiresAt: any, completedAt?: any | null, fileRequestId: string, email: string, name: string, kbaEnable: boolean, createAt: any, updateAt: any, KBA?: Array<{ __typename?: 'KbaEntity', id: string, type: Types.KbaType, createAt: any, updateAt: any, isValidated: boolean, fileApprovalId?: string | null, isIdScanPassed: boolean, isIdScanPending: boolean, numKbaAttempts?: number | null, numFailedIdScans?: number | null, numKbaFailedAttempts?: number | null, numRequestedIdScans?: number | null, KBAFields?: Array<{ __typename?: 'KBAFieldEntity', id: string, type: Types.QuestionType, value?: string | null, KBAId: string, createAt: any, updateAt: any, description?: string | null }> | null }> | null }> | null };

export type GetClientsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Float']>;
  take?: Types.InputMaybe<Types.Scalars['Float']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']>;
  orderBy?: Types.InputMaybe<Types.UserFirmAccountOrderByInput>;
}>;


export type GetClientsQuery = { __typename?: 'Query', Clients: { __typename?: 'PaginationUserFirmAccountResponseEntity', pagination: { __typename?: 'UserFirmAccountPagination', total: number }, data: Array<{ __typename?: 'UserFirmAccountEntity', Entity?: { __typename?: 'Entity', id: string, ownerId: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, invitationEmailSent?: boolean | null, hasPassword?: boolean | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, birthday?: any | null, notes?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, createAt: any, updateAt: any, userInformationId?: string | null, value: string, type: Types.PhoneType }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string }> | null } | null, ReferredByUser?: { __typename?: 'UserEntity', email?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null } | null, TaxYear?: Array<{ __typename?: 'TaxYearEntity', id: string, year: number, createAt: any, TaxYearInterview?: Array<{ __typename?: 'TaxYearInterviewEntity', id: string, taxYearId: string, preparedId?: string | null, reviewedId?: string | null, progressStatusId?: string | null, notes?: string | null, assignedAt: any, completedAt?: any | null, reviewStatus?: Types.ReviewStatus | null, preparerAcceptedAt?: any | null, createAt: any, updateAt: any, JobTracking?: { __typename?: 'JobTrackingEntity', id: string, expectedCompletion?: any | null, paymentsCompletedAt?: any | null, approvalsCompletedAt?: any | null, interviewCompletedAt?: any | null, filesCompletedAt?: any | null } | null, Tasks?: Array<{ __typename?: 'TaskEntity', id: string, taskType?: Types.TaskType | null, createAt: any, updateAt: any, taxYearId?: string | null, deletedAt?: any | null, completedAt?: any | null }> | null, PreparedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null } } | null, ReviewedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null } } | null, Interviews?: { __typename?: 'InterviewEntity', id: string, firmAccountId: string, name: string, isTemplate: boolean, isLive: boolean, drakePackage?: string | null, createAt: any, updateAt: any } | null }> | null }> | null } | null }> } };

export type GetDeletedClientsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Float']>;
  take?: Types.InputMaybe<Types.Scalars['Float']>;
  orderBy?: Types.InputMaybe<Types.UserFirmAccountOrderByInput>;
}>;


export type GetDeletedClientsQuery = { __typename?: 'Query', DeletedClients: { __typename?: 'PaginationUserFirmAccountResponseEntity', pagination: { __typename?: 'UserFirmAccountPagination', total: number }, data: Array<{ __typename?: 'UserFirmAccountEntity', deleteAt?: any | null, id: string, Entity?: { __typename?: 'Entity', id: string, ownerId: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null } | null, TaxYear?: Array<{ __typename?: 'TaxYearEntity', id: string, year: number, TaxYearInterview?: Array<{ __typename?: 'TaxYearInterviewEntity', id: string, taxYearId: string, Interviews?: { __typename?: 'InterviewEntity', id: string, name: string } | null }> | null }> | null } | null }> } };

export type LanguageEntityFragment = { __typename?: 'LanguagesEntity', id: string, lang: string, description?: string | null };

export type ClientsByStatusFragment = { __typename?: 'TaxYearInterviewEntity', id: string, notes?: string | null, progressStatusId?: string | null, createAt: any, updateAt: any, taxYearId: string, preparedId?: string | null, reviewedId?: string | null, assignedAt: any, interviewId: string, completedAt?: any | null, reviewStatus?: Types.ReviewStatus | null, JobTracking?: { __typename?: 'JobTrackingEntity', id: string, expectedCompletion?: any | null, paymentsCompletedAt?: any | null, approvalsCompletedAt?: any | null, interviewCompletedAt?: any | null, filesCompletedAt?: any | null } | null, Tasks?: Array<{ __typename?: 'TaskEntity', id: string, taskType?: Types.TaskType | null, createAt: any, updateAt: any, taxYearId?: string | null, deletedAt?: any | null, completedAt?: any | null }> | null, PreparedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, createAt?: any | null, lastName: string, updateAt?: any | null, firstName: string } } | null, ReviewedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, lastName: string, createAt?: any | null, updateAt?: any | null, firstName: string } } | null, TaxYear?: { __typename?: 'TaxYearEntity', id: string, year: number, entityId: string, createAt: any, Entity?: { __typename?: 'Entity', id: string, ownerId: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, invitationEmailSent?: boolean | null, hasPassword?: boolean | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, type: Types.PhoneType, value: string, createAt: any, updateAt: any }> | null } | null, ReferredByUser?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null } | null } | null } | null, Interviews?: { __typename?: 'InterviewEntity', id: string, name: string, isLive: boolean, createAt: any, updateAt: any, isTemplate: boolean, firmAccountId: string } | null };

export type GetClientsByProgressStatusIdQueryVariables = Types.Exact<{
  progressStatusId: Types.Scalars['String'];
  skip?: Types.InputMaybe<Types.Scalars['Float']>;
  take?: Types.InputMaybe<Types.Scalars['Float']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']>;
  orderBy?: Types.InputMaybe<Types.TaxYearInterviewOrderByInput>;
}>;


export type GetClientsByProgressStatusIdQuery = { __typename?: 'Query', ClientsByTaxYearStatus: { __typename?: 'PaginationTaxYearInterviewResponseEntity', data: Array<{ __typename?: 'TaxYearInterviewEntity', id: string, notes?: string | null, progressStatusId?: string | null, createAt: any, updateAt: any, taxYearId: string, preparedId?: string | null, reviewedId?: string | null, assignedAt: any, interviewId: string, completedAt?: any | null, reviewStatus?: Types.ReviewStatus | null, JobTracking?: { __typename?: 'JobTrackingEntity', id: string, expectedCompletion?: any | null, paymentsCompletedAt?: any | null, approvalsCompletedAt?: any | null, interviewCompletedAt?: any | null, filesCompletedAt?: any | null } | null, Tasks?: Array<{ __typename?: 'TaskEntity', id: string, taskType?: Types.TaskType | null, createAt: any, updateAt: any, taxYearId?: string | null, deletedAt?: any | null, completedAt?: any | null }> | null, PreparedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, createAt?: any | null, lastName: string, updateAt?: any | null, firstName: string } } | null, ReviewedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, lastName: string, createAt?: any | null, updateAt?: any | null, firstName: string } } | null, TaxYear?: { __typename?: 'TaxYearEntity', id: string, year: number, entityId: string, createAt: any, Entity?: { __typename?: 'Entity', id: string, ownerId: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, invitationEmailSent?: boolean | null, hasPassword?: boolean | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, type: Types.PhoneType, value: string, createAt: any, updateAt: any }> | null } | null, ReferredByUser?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null } | null } | null } | null, Interviews?: { __typename?: 'InterviewEntity', id: string, name: string, isLive: boolean, createAt: any, updateAt: any, isTemplate: boolean, firmAccountId: string } | null }>, pagination: { __typename?: 'TaxYearInterviewPagination', total: number } } };

export type GetOtpBooleanQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOtpBooleanQuery = { __typename?: 'Query', GetOTPBoolean: { __typename?: 'UserSuccessEntity', success: boolean, apiToken?: string | null } };

export type CustomDomainUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomDomainUserQuery = { __typename?: 'Query', CustomDomainUser?: { __typename?: 'CustomDomainsEntity', id: string, name: string, certificateArn?: string | null, cloudfrontIdId?: string | null, status?: Types.CustomDomainStatuses | null, firmAccountId?: string | null } | null };

export type CurrentStripeInformationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentStripeInformationQuery = { __typename?: 'Query', CurrentStripeInformation: { __typename?: 'StripeInformationEntity', id: string, customerId: string, subscriptionId?: string | null, firmAccountId: string, plan?: string | null, connectAccountId?: string | null, finishedOnboarding: boolean } };

export type GetInvoicesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetInvoicesQuery = { __typename?: 'Query', GetInvoices: Array<{ __typename?: 'StripeInvoiceEntity', id: string, created: any, number: string, amountDue: number, paid: number, pdf?: string | null }> };

export type GetPaymentIntentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPaymentIntentsQuery = { __typename?: 'Query', GetPaymentIntents: Array<{ __typename?: 'StripePaymentIntentWithRefundsEntity', id?: string | null, created?: number | null, amount?: number | null, amount_capturable?: number | null, amount_received?: number | null, receipt_email?: string | null, description?: string | null, refunds?: Array<{ __typename?: 'StripeRefundEntity', id?: string | null, amount: number, created: number, status?: string | null }> | null }> };

export type GetUpcomingInvoiceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUpcomingInvoiceQuery = { __typename?: 'Query', GetUpcomingInvoice: { __typename?: 'StripeInvoiceUpcomingEntity', created: any, number: string, amountDue: number, discount: string, startingBalance: number, endingBalance: number, nextPayment: any, periodStart: any, periodEnd: any } };

export type GetNylasAccountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetNylasAccountsQuery = { __typename?: 'Query', getNylasAccounts: Array<{ __typename?: 'NylasApiAccountEntity', accountId?: string | null, provider?: string | null, syncState?: string | null, emailAddress?: string | null, accessToken?: string | null }> };

export type IsActiveFirmQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IsActiveFirmQuery = { __typename?: 'Query', isActiveFirm: boolean };

export type GetFirmSettingsQueryVariables = Types.Exact<{
  category: Types.Scalars['String'];
}>;


export type GetFirmSettingsQuery = { __typename?: 'Query', getFirmSettings: Array<{ __typename?: 'FirmSettingsEntity', id?: string | null, name: string, description: string, type: Types.SettingsType, category: Types.SettingsCategory, value: { __typename?: 'BooleanValue', boolValue: boolean } | { __typename?: 'DateValue', dateValue: any } | { __typename?: 'NumberValue', numValue: number } | { __typename?: 'StringValue', strValue: string } }> };

export type GetFirmSettingQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type GetFirmSettingQuery = { __typename?: 'Query', getFirmSetting: { __typename?: 'FirmSettingsEntity', id?: string | null, name: string, description: string, type: Types.SettingsType, category: Types.SettingsCategory, value: { __typename?: 'BooleanValue', boolValue: boolean } | { __typename?: 'DateValue', dateValue: any } | { __typename?: 'NumberValue', numValue: number } | { __typename?: 'StringValue', strValue: string } } };

export type GetClientsBasicInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetClientsBasicInfoQuery = { __typename?: 'Query', getClientsBasicInfo: Array<{ __typename?: 'UserFirmAccountEntity', id: string, Entity?: { __typename?: 'Entity', id: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string } | null } | null } | null }> };

export const StripeMetaDataFragmentDoc = gql`
    fragment StripeMetaData on StripeMetadataEntity {
  plan_name
  taxaroo_plus
  has_roo_access
  custom_plan
}
    `;
export const InvoicesFragmentDoc = gql`
    fragment Invoices on InvoicesEntity {
  id
  quantity
  createAt
  updateAt
  priceEach
  paymentId
  description
}
    `;
export const PaymentsFragmentDoc = gql`
    fragment Payments on PaymentsEntity {
  id
  taskId
  createAt
  updateAt
  entityId
  requestAt
  deletedAt
  promisedAt
  completedAt
  paidOffline
  referralFee
  preparerFee
  firmAccountId
  discountApplied
  totalDollarAmount
  taxYearInterviewId
  paymentProcessorId
  Invoices {
    ...Invoices
  }
}
    ${InvoicesFragmentDoc}`;
export const SignatureFieldFragmentDoc = gql`
    fragment SignatureField on SignatureFieldEntity {
  id
  page
  fieldId
  createAt
  updateAt
  fieldType
  signatureId
  signerParty
  fieldTopPercentage
  fieldLeftPercentage
  fieldWidthPercentage
  fieldHeightPercentage
}
    `;
export const SignatureFragmentDoc = gql`
    fragment Signature on SignatureEntity {
  id
  fileId
  createAt
  updateAt
  fileRequestId
  SignatureFields {
    ...SignatureField
  }
}
    ${SignatureFieldFragmentDoc}`;
export const FileFragmentDoc = gql`
    fragment File on FileEntity {
  id
  name
  size
  s3Key
  pages
  folder
  userId
  createAt
  updateAt
  deleteAt
  uploadedBy
  documentUsed
  firmAccountId
  taxYearInterviewId
  Signatures {
    ...Signature
  }
}
    ${SignatureFragmentDoc}`;
export const KbaFieldsFragmentDoc = gql`
    fragment KBAFields on KBAFieldEntity {
  id
  type
  value
  KBAId
  createAt
  updateAt
  description
}
    `;
export const KbaFragmentDoc = gql`
    fragment KBA on KbaEntity {
  id
  type
  createAt
  updateAt
  isValidated
  fileApprovalId
  isIdScanPassed
  isIdScanPending
  numKbaAttempts
  numFailedIdScans
  numKbaFailedAttempts
  numRequestedIdScans
  KBAFields {
    ...KBAFields
  }
}
    ${KbaFieldsFragmentDoc}`;
export const FileApprovalFragmentDoc = gql`
    fragment FileApproval on FileApprovalEntity {
  id
  expiresAt
  completedAt
  fileRequestId
  email
  name
  kbaEnable
  createAt
  updateAt
  KBA {
    ...KBA
  }
}
    ${KbaFragmentDoc}`;
export const FileRequestFragmentDoc = gql`
    fragment FileRequest on FileRequestEntity {
  id
  title
  notes
  userId
  taskId
  clientId
  createAt
  updateAt
  compiledHash
  signedFileId
  firmAccountId
  compiledFileId
  signatureRequest
  signatureComplete
  taxYearInterviewId
  Signatures {
    ...Signature
  }
  CompiledFile {
    ...File
  }
  SignedFile {
    ...File
  }
  FileApprovals {
    ...FileApproval
  }
}
    ${SignatureFragmentDoc}
${FileFragmentDoc}
${FileApprovalFragmentDoc}`;
export const LanguageEntityFragmentDoc = gql`
    fragment LanguageEntity on LanguagesEntity {
  id
  lang
  description
}
    `;
export const ClientsByStatusFragmentDoc = gql`
    fragment ClientsByStatus on TaxYearInterviewEntity {
  id
  notes
  progressStatusId
  createAt
  updateAt
  taxYearId
  preparedId
  reviewedId
  assignedAt
  interviewId
  completedAt
  reviewStatus
  progressStatusId
  JobTracking {
    id
    expectedCompletion
    paymentsCompletedAt
    approvalsCompletedAt
    interviewCompletedAt
    filesCompletedAt
  }
  Tasks {
    id
    taskType
    createAt
    updateAt
    taxYearId
    deletedAt
    completedAt
  }
  PreparedUser {
    id
    email
    UserInformation {
      id
      userId
      birthday
      createAt
      lastName
      updateAt
      firstName
    }
  }
  ReviewedUser {
    id
    email
    UserInformation {
      id
      userId
      birthday
      lastName
      createAt
      updateAt
      firstName
    }
  }
  TaxYear {
    id
    year
    entityId
    createAt
    Entity {
      id
      ownerId
      Users {
        id
        email
        createAt
        updateAt
        languageId
        invitationEmailSent
        hasPassword
        UserInformation {
          id
          userId
          birthday
          firstName
          lastName
          createAt
          updateAt
          Phones {
            id
            type
            value
            createAt
            updateAt
          }
        }
        ReferredByUser {
          id
          email
          createAt
          updateAt
          languageId
          UserInformation {
            firstName
            lastName
          }
        }
      }
    }
  }
  Interviews {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    firmAccountId
  }
}
    `;
export const GetCustomDomainUserDocument = gql`
    query GetCustomDomainUser {
  CustomDomainUser {
    id
    name
    certificateArn
    cloudfrontIdId
    status
    firmAccountId
  }
}
    `;

/**
 * __useGetCustomDomainUserQuery__
 *
 * To run a query within a React component, call `useGetCustomDomainUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomDomainUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomDomainUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomDomainUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomDomainUserQuery, GetCustomDomainUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomDomainUserQuery, GetCustomDomainUserQueryVariables>(GetCustomDomainUserDocument, options);
      }
export function useGetCustomDomainUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomDomainUserQuery, GetCustomDomainUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomDomainUserQuery, GetCustomDomainUserQueryVariables>(GetCustomDomainUserDocument, options);
        }
export type GetCustomDomainUserQueryHookResult = ReturnType<typeof useGetCustomDomainUserQuery>;
export type GetCustomDomainUserLazyQueryHookResult = ReturnType<typeof useGetCustomDomainUserLazyQuery>;
export type GetCustomDomainUserQueryResult = Apollo.QueryResult<GetCustomDomainUserQuery, GetCustomDomainUserQueryVariables>;
export const CustomDomainCertificateStatusDocument = gql`
    query CustomDomainCertificateStatus {
  CustomDomainCertificateStatus {
    id
    Status
    FailureReason
    DomainValidationOptions {
      name
      type
      value
    }
  }
}
    `;

/**
 * __useCustomDomainCertificateStatusQuery__
 *
 * To run a query within a React component, call `useCustomDomainCertificateStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDomainCertificateStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDomainCertificateStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomDomainCertificateStatusQuery(baseOptions?: Apollo.QueryHookOptions<CustomDomainCertificateStatusQuery, CustomDomainCertificateStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDomainCertificateStatusQuery, CustomDomainCertificateStatusQueryVariables>(CustomDomainCertificateStatusDocument, options);
      }
export function useCustomDomainCertificateStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDomainCertificateStatusQuery, CustomDomainCertificateStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDomainCertificateStatusQuery, CustomDomainCertificateStatusQueryVariables>(CustomDomainCertificateStatusDocument, options);
        }
export type CustomDomainCertificateStatusQueryHookResult = ReturnType<typeof useCustomDomainCertificateStatusQuery>;
export type CustomDomainCertificateStatusLazyQueryHookResult = ReturnType<typeof useCustomDomainCertificateStatusLazyQuery>;
export type CustomDomainCertificateStatusQueryResult = Apollo.QueryResult<CustomDomainCertificateStatusQuery, CustomDomainCertificateStatusQueryVariables>;
export const CustomDomainCnameStatusDocument = gql`
    query CustomDomainCnameStatus {
  CustomDomainCnameStatus {
    hostname
    cnameStatus
    distribution {
      Id
      ARN
      Status
      DomainName
      Aliases {
        Items
        Quantity
      }
    }
  }
}
    `;

/**
 * __useCustomDomainCnameStatusQuery__
 *
 * To run a query within a React component, call `useCustomDomainCnameStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDomainCnameStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDomainCnameStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomDomainCnameStatusQuery(baseOptions?: Apollo.QueryHookOptions<CustomDomainCnameStatusQuery, CustomDomainCnameStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDomainCnameStatusQuery, CustomDomainCnameStatusQueryVariables>(CustomDomainCnameStatusDocument, options);
      }
export function useCustomDomainCnameStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDomainCnameStatusQuery, CustomDomainCnameStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDomainCnameStatusQuery, CustomDomainCnameStatusQueryVariables>(CustomDomainCnameStatusDocument, options);
        }
export type CustomDomainCnameStatusQueryHookResult = ReturnType<typeof useCustomDomainCnameStatusQuery>;
export type CustomDomainCnameStatusLazyQueryHookResult = ReturnType<typeof useCustomDomainCnameStatusLazyQuery>;
export type CustomDomainCnameStatusQueryResult = Apollo.QueryResult<CustomDomainCnameStatusQuery, CustomDomainCnameStatusQueryVariables>;
export const IsDomainLiveDocument = gql`
    query IsDomainLive($url: String!) {
  IsDomainLive(url: $url)
}
    `;

/**
 * __useIsDomainLiveQuery__
 *
 * To run a query within a React component, call `useIsDomainLiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDomainLiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDomainLiveQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useIsDomainLiveQuery(baseOptions: Apollo.QueryHookOptions<IsDomainLiveQuery, IsDomainLiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDomainLiveQuery, IsDomainLiveQueryVariables>(IsDomainLiveDocument, options);
      }
export function useIsDomainLiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDomainLiveQuery, IsDomainLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDomainLiveQuery, IsDomainLiveQueryVariables>(IsDomainLiveDocument, options);
        }
export type IsDomainLiveQueryHookResult = ReturnType<typeof useIsDomainLiveQuery>;
export type IsDomainLiveLazyQueryHookResult = ReturnType<typeof useIsDomainLiveLazyQuery>;
export type IsDomainLiveQueryResult = Apollo.QueryResult<IsDomainLiveQuery, IsDomainLiveQueryVariables>;
export const GetCloudFrontDistributionByCertificateArnDocument = gql`
    query GetCloudFrontDistributionByCertificateArn {
  GetCloudFrontDistributionByCertificateArn {
    Id
    ARN
    Status
    DomainName
    Aliases {
      Items
      Quantity
    }
  }
}
    `;

/**
 * __useGetCloudFrontDistributionByCertificateArnQuery__
 *
 * To run a query within a React component, call `useGetCloudFrontDistributionByCertificateArnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudFrontDistributionByCertificateArnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudFrontDistributionByCertificateArnQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCloudFrontDistributionByCertificateArnQuery(baseOptions?: Apollo.QueryHookOptions<GetCloudFrontDistributionByCertificateArnQuery, GetCloudFrontDistributionByCertificateArnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCloudFrontDistributionByCertificateArnQuery, GetCloudFrontDistributionByCertificateArnQueryVariables>(GetCloudFrontDistributionByCertificateArnDocument, options);
      }
export function useGetCloudFrontDistributionByCertificateArnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCloudFrontDistributionByCertificateArnQuery, GetCloudFrontDistributionByCertificateArnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCloudFrontDistributionByCertificateArnQuery, GetCloudFrontDistributionByCertificateArnQueryVariables>(GetCloudFrontDistributionByCertificateArnDocument, options);
        }
export type GetCloudFrontDistributionByCertificateArnQueryHookResult = ReturnType<typeof useGetCloudFrontDistributionByCertificateArnQuery>;
export type GetCloudFrontDistributionByCertificateArnLazyQueryHookResult = ReturnType<typeof useGetCloudFrontDistributionByCertificateArnLazyQuery>;
export type GetCloudFrontDistributionByCertificateArnQueryResult = Apollo.QueryResult<GetCloudFrontDistributionByCertificateArnQuery, GetCloudFrontDistributionByCertificateArnQueryVariables>;
export const GetCustomLayoutsDocument = gql`
    query GetCustomLayouts {
  CustomLayout {
    id
    firmAccountId
    headerBackgroundColor
    headerFontColor
    logo
    pixelCode
  }
}
    `;

/**
 * __useGetCustomLayoutsQuery__
 *
 * To run a query within a React component, call `useGetCustomLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomLayoutsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomLayoutsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>(GetCustomLayoutsDocument, options);
      }
export function useGetCustomLayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>(GetCustomLayoutsDocument, options);
        }
export type GetCustomLayoutsQueryHookResult = ReturnType<typeof useGetCustomLayoutsQuery>;
export type GetCustomLayoutsLazyQueryHookResult = ReturnType<typeof useGetCustomLayoutsLazyQuery>;
export type GetCustomLayoutsQueryResult = Apollo.QueryResult<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>;
export const GetUserInformationDocument = gql`
    query GetUserInformation($id: String!) {
  UserInformation(id: $id) {
    firstName
    lastName
    birthday
    ssn
    Address {
      id
      lineOne
      lineTwo
      city
      state
      type
      zip
    }
    Phones {
      id
      value
      type
    }
  }
}
    `;

/**
 * __useGetUserInformationQuery__
 *
 * To run a query within a React component, call `useGetUserInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserInformationQuery(baseOptions: Apollo.QueryHookOptions<GetUserInformationQuery, GetUserInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, options);
      }
export function useGetUserInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInformationQuery, GetUserInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, options);
        }
export type GetUserInformationQueryHookResult = ReturnType<typeof useGetUserInformationQuery>;
export type GetUserInformationLazyQueryHookResult = ReturnType<typeof useGetUserInformationLazyQuery>;
export type GetUserInformationQueryResult = Apollo.QueryResult<GetUserInformationQuery, GetUserInformationQueryVariables>;
export const GetSubscriptionDocument = gql`
    query GetSubscription {
  GetSubscriptionByContext {
    id
    object
    application_fee_percent
    billing_cycle_anchor
    cancel_at
    cancel_at_period_end
    canceled_at
    created
    current_period_end
    current_period_start
    customer
    days_until_due
    default_payment_method
    default_source
    ended_at
    livemode
    items {
      object
      data {
        id
        object
        billing_thresholds {
          usage_gte
        }
        created
        plan {
          id
          object
          active
          amount
          amount_decimal
          billing_scheme
          created
          currency
          interval
          interval_count
          livemode
          tiers_mode
          trial_period_days
          product
          tiers {
            flat_amount
            flat_amount_decimal
            unit_amount
            unit_amount_decimal
            up_to
          }
          metadata {
            ...StripeMetaData
          }
        }
      }
    }
    metadata {
      ...StripeMetaData
    }
    next_pending_invoice_item_invoice
    pending_setup_intent
    schedule
    start_date
    status
    trial_end
    trial_start
    quantity
    pause_collection {
      behavior
      resumes_at
    }
  }
}
    ${StripeMetaDataFragmentDoc}`;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const GetAllPlansDocument = gql`
    query GetAllPlans {
  GetAllPlans {
    id
    active
    amount
    amount_decimal
    created
    currency
    interval
    interval_count
    livemode
    nickname
    tiers {
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
      up_to
    }
    metadata {
      ...StripeMetaData
    }
    product
    tiers_mode
    trial_period_days
  }
}
    ${StripeMetaDataFragmentDoc}`;

/**
 * __useGetAllPlansQuery__
 *
 * To run a query within a React component, call `useGetAllPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPlansQuery, GetAllPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPlansQuery, GetAllPlansQueryVariables>(GetAllPlansDocument, options);
      }
export function useGetAllPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPlansQuery, GetAllPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPlansQuery, GetAllPlansQueryVariables>(GetAllPlansDocument, options);
        }
export type GetAllPlansQueryHookResult = ReturnType<typeof useGetAllPlansQuery>;
export type GetAllPlansLazyQueryHookResult = ReturnType<typeof useGetAllPlansLazyQuery>;
export type GetAllPlansQueryResult = Apollo.QueryResult<GetAllPlansQuery, GetAllPlansQueryVariables>;
export const GetPlansByProductIdDocument = gql`
    query GetPlansByProductId($productId: String!) {
  GetPlansByProductId(productId: $productId) {
    id
    active
    amount
    amount_decimal
    created
    currency
    interval
    interval_count
    livemode
    nickname
    tiers {
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
      up_to
    }
    metadata {
      ...StripeMetaData
    }
    product
    tiers_mode
    billing_scheme
    trial_period_days
  }
}
    ${StripeMetaDataFragmentDoc}`;

/**
 * __useGetPlansByProductIdQuery__
 *
 * To run a query within a React component, call `useGetPlansByProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansByProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansByProductIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetPlansByProductIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlansByProductIdQuery, GetPlansByProductIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansByProductIdQuery, GetPlansByProductIdQueryVariables>(GetPlansByProductIdDocument, options);
      }
export function useGetPlansByProductIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansByProductIdQuery, GetPlansByProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansByProductIdQuery, GetPlansByProductIdQueryVariables>(GetPlansByProductIdDocument, options);
        }
export type GetPlansByProductIdQueryHookResult = ReturnType<typeof useGetPlansByProductIdQuery>;
export type GetPlansByProductIdLazyQueryHookResult = ReturnType<typeof useGetPlansByProductIdLazyQuery>;
export type GetPlansByProductIdQueryResult = Apollo.QueryResult<GetPlansByProductIdQuery, GetPlansByProductIdQueryVariables>;
export const GetPlanDocument = gql`
    query GetPlan($planId: String!) {
  GetPlan(planId: $planId) {
    id
    currency
    interval
    tiers_mode
    product
  }
}
    `;

/**
 * __useGetPlanQuery__
 *
 * To run a query within a React component, call `useGetPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useGetPlanQuery(baseOptions: Apollo.QueryHookOptions<GetPlanQuery, GetPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
      }
export function useGetPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanQuery, GetPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanQuery, GetPlanQueryVariables>(GetPlanDocument, options);
        }
export type GetPlanQueryHookResult = ReturnType<typeof useGetPlanQuery>;
export type GetPlanLazyQueryHookResult = ReturnType<typeof useGetPlanLazyQuery>;
export type GetPlanQueryResult = Apollo.QueryResult<GetPlanQuery, GetPlanQueryVariables>;
export const GetUserUniqueLinkDocument = gql`
    query GetUserUniqueLink($id: String!) {
  UserById(id: $id) {
    id
    uniqueLink
  }
}
    `;

/**
 * __useGetUserUniqueLinkQuery__
 *
 * To run a query within a React component, call `useGetUserUniqueLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUniqueLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUniqueLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserUniqueLinkQuery(baseOptions: Apollo.QueryHookOptions<GetUserUniqueLinkQuery, GetUserUniqueLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserUniqueLinkQuery, GetUserUniqueLinkQueryVariables>(GetUserUniqueLinkDocument, options);
      }
export function useGetUserUniqueLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserUniqueLinkQuery, GetUserUniqueLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserUniqueLinkQuery, GetUserUniqueLinkQueryVariables>(GetUserUniqueLinkDocument, options);
        }
export type GetUserUniqueLinkQueryHookResult = ReturnType<typeof useGetUserUniqueLinkQuery>;
export type GetUserUniqueLinkLazyQueryHookResult = ReturnType<typeof useGetUserUniqueLinkLazyQuery>;
export type GetUserUniqueLinkQueryResult = Apollo.QueryResult<GetUserUniqueLinkQuery, GetUserUniqueLinkQueryVariables>;
export const GetFirmUniqueLinkDocument = gql`
    query GetFirmUniqueLink($id: String!) {
  FirmAccountById(id: $id) {
    id
    uniqueLink
  }
}
    `;

/**
 * __useGetFirmUniqueLinkQuery__
 *
 * To run a query within a React component, call `useGetFirmUniqueLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmUniqueLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmUniqueLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFirmUniqueLinkQuery(baseOptions: Apollo.QueryHookOptions<GetFirmUniqueLinkQuery, GetFirmUniqueLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmUniqueLinkQuery, GetFirmUniqueLinkQueryVariables>(GetFirmUniqueLinkDocument, options);
      }
export function useGetFirmUniqueLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmUniqueLinkQuery, GetFirmUniqueLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmUniqueLinkQuery, GetFirmUniqueLinkQueryVariables>(GetFirmUniqueLinkDocument, options);
        }
export type GetFirmUniqueLinkQueryHookResult = ReturnType<typeof useGetFirmUniqueLinkQuery>;
export type GetFirmUniqueLinkLazyQueryHookResult = ReturnType<typeof useGetFirmUniqueLinkLazyQuery>;
export type GetFirmUniqueLinkQueryResult = Apollo.QueryResult<GetFirmUniqueLinkQuery, GetFirmUniqueLinkQueryVariables>;
export const GetProgressStatusesDocument = gql`
    query GetProgressStatuses {
  ProgressStatuses {
    id
    firmAccountId
    status
    underlyingStatus
    index
  }
}
    `;

/**
 * __useGetProgressStatusesQuery__
 *
 * To run a query within a React component, call `useGetProgressStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgressStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetProgressStatusesQuery, GetProgressStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressStatusesQuery, GetProgressStatusesQueryVariables>(GetProgressStatusesDocument, options);
      }
export function useGetProgressStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressStatusesQuery, GetProgressStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressStatusesQuery, GetProgressStatusesQueryVariables>(GetProgressStatusesDocument, options);
        }
export type GetProgressStatusesQueryHookResult = ReturnType<typeof useGetProgressStatusesQuery>;
export type GetProgressStatusesLazyQueryHookResult = ReturnType<typeof useGetProgressStatusesLazyQuery>;
export type GetProgressStatusesQueryResult = Apollo.QueryResult<GetProgressStatusesQuery, GetProgressStatusesQueryVariables>;
export const GetUserFirmAccountByFirmAccountDocument = gql`
    query GetUserFirmAccountByFirmAccount($firmAccountId: String!) {
  UserFirmAccountByFirmAccount(firmAccountId: $firmAccountId) {
    id
    userId
    roleId
    firmAccountId
  }
}
    `;

/**
 * __useGetUserFirmAccountByFirmAccountQuery__
 *
 * To run a query within a React component, call `useGetUserFirmAccountByFirmAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFirmAccountByFirmAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFirmAccountByFirmAccountQuery({
 *   variables: {
 *      firmAccountId: // value for 'firmAccountId'
 *   },
 * });
 */
export function useGetUserFirmAccountByFirmAccountQuery(baseOptions: Apollo.QueryHookOptions<GetUserFirmAccountByFirmAccountQuery, GetUserFirmAccountByFirmAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFirmAccountByFirmAccountQuery, GetUserFirmAccountByFirmAccountQueryVariables>(GetUserFirmAccountByFirmAccountDocument, options);
      }
export function useGetUserFirmAccountByFirmAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFirmAccountByFirmAccountQuery, GetUserFirmAccountByFirmAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFirmAccountByFirmAccountQuery, GetUserFirmAccountByFirmAccountQueryVariables>(GetUserFirmAccountByFirmAccountDocument, options);
        }
export type GetUserFirmAccountByFirmAccountQueryHookResult = ReturnType<typeof useGetUserFirmAccountByFirmAccountQuery>;
export type GetUserFirmAccountByFirmAccountLazyQueryHookResult = ReturnType<typeof useGetUserFirmAccountByFirmAccountLazyQuery>;
export type GetUserFirmAccountByFirmAccountQueryResult = Apollo.QueryResult<GetUserFirmAccountByFirmAccountQuery, GetUserFirmAccountByFirmAccountQueryVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: String!) {
  UserById(id: $id) {
    id
    email
    uniqueLink
    UserInformation {
      firstName
      lastName
      Phones {
        id
        value
        type
        createAt
        updateAt
      }
      Address {
        id
        lineOne
        lineTwo
        city
        state
        type
        zip
        createAt
        updateAt
      }
    }
    Entity {
      id
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles {
  Roles {
    id
    description
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetUserFirmAccountByFirmAccountAndFilterDocument = gql`
    query GetUserFirmAccountByFirmAccountAndFilter($firmAccountId: String!, $filterDelete: Boolean!) {
  UserFirmAccountByFirmAccountAndFilter(
    firmAccountId: $firmAccountId
    filterDelete: $filterDelete
  ) {
    id
    roleId
    firmAccountId
    Users {
      id
      email
      deleteAt
      UserInformation {
        id
        firstName
        lastName
      }
    }
    Roles {
      id
      description
    }
  }
}
    `;

/**
 * __useGetUserFirmAccountByFirmAccountAndFilterQuery__
 *
 * To run a query within a React component, call `useGetUserFirmAccountByFirmAccountAndFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFirmAccountByFirmAccountAndFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFirmAccountByFirmAccountAndFilterQuery({
 *   variables: {
 *      firmAccountId: // value for 'firmAccountId'
 *      filterDelete: // value for 'filterDelete'
 *   },
 * });
 */
export function useGetUserFirmAccountByFirmAccountAndFilterQuery(baseOptions: Apollo.QueryHookOptions<GetUserFirmAccountByFirmAccountAndFilterQuery, GetUserFirmAccountByFirmAccountAndFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFirmAccountByFirmAccountAndFilterQuery, GetUserFirmAccountByFirmAccountAndFilterQueryVariables>(GetUserFirmAccountByFirmAccountAndFilterDocument, options);
      }
export function useGetUserFirmAccountByFirmAccountAndFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFirmAccountByFirmAccountAndFilterQuery, GetUserFirmAccountByFirmAccountAndFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFirmAccountByFirmAccountAndFilterQuery, GetUserFirmAccountByFirmAccountAndFilterQueryVariables>(GetUserFirmAccountByFirmAccountAndFilterDocument, options);
        }
export type GetUserFirmAccountByFirmAccountAndFilterQueryHookResult = ReturnType<typeof useGetUserFirmAccountByFirmAccountAndFilterQuery>;
export type GetUserFirmAccountByFirmAccountAndFilterLazyQueryHookResult = ReturnType<typeof useGetUserFirmAccountByFirmAccountAndFilterLazyQuery>;
export type GetUserFirmAccountByFirmAccountAndFilterQueryResult = Apollo.QueryResult<GetUserFirmAccountByFirmAccountAndFilterQuery, GetUserFirmAccountByFirmAccountAndFilterQueryVariables>;
export const GenerateOtpDocument = gql`
    query GenerateOTP {
  generateOTP {
    codeQR
    key
  }
}
    `;

/**
 * __useGenerateOtpQuery__
 *
 * To run a query within a React component, call `useGenerateOtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateOtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateOtpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateOtpQuery(baseOptions?: Apollo.QueryHookOptions<GenerateOtpQuery, GenerateOtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateOtpQuery, GenerateOtpQueryVariables>(GenerateOtpDocument, options);
      }
export function useGenerateOtpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateOtpQuery, GenerateOtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateOtpQuery, GenerateOtpQueryVariables>(GenerateOtpDocument, options);
        }
export type GenerateOtpQueryHookResult = ReturnType<typeof useGenerateOtpQuery>;
export type GenerateOtpLazyQueryHookResult = ReturnType<typeof useGenerateOtpLazyQuery>;
export type GenerateOtpQueryResult = Apollo.QueryResult<GenerateOtpQuery, GenerateOtpQueryVariables>;
export const FirmAccountByIdDocument = gql`
    query FirmAccountById($id: String!) {
  FirmAccountById(id: $id) {
    id
    name
    type
    businessType
    uniqueLink
    createAt
    updateAt
    deleteAt
  }
}
    `;

/**
 * __useFirmAccountByIdQuery__
 *
 * To run a query within a React component, call `useFirmAccountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmAccountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmAccountByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFirmAccountByIdQuery(baseOptions: Apollo.QueryHookOptions<FirmAccountByIdQuery, FirmAccountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirmAccountByIdQuery, FirmAccountByIdQueryVariables>(FirmAccountByIdDocument, options);
      }
export function useFirmAccountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirmAccountByIdQuery, FirmAccountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirmAccountByIdQuery, FirmAccountByIdQueryVariables>(FirmAccountByIdDocument, options);
        }
export type FirmAccountByIdQueryHookResult = ReturnType<typeof useFirmAccountByIdQuery>;
export type FirmAccountByIdLazyQueryHookResult = ReturnType<typeof useFirmAccountByIdLazyQuery>;
export type FirmAccountByIdQueryResult = Apollo.QueryResult<FirmAccountByIdQuery, FirmAccountByIdQueryVariables>;
export const GetBusinessInformationDocument = gql`
    query GetBusinessInformation {
  BusinessInformation {
    id
    taxReturns
    yearsInBusiness
    taxPercent
    accountingPercent
    bookKeepingPercent
    payrollPercent
    taxResolutionPercent
    other
    firmAccountId
    Phones {
      id
      value
      userInformationId
      businessInformationId
      createAt
      updateAt
      type
    }
    Address {
      id
      lineOne
      lineTwo
      city
      state
      type
      zip
      userInformationId
      businessInformationId
      createAt
      updateAt
    }
    FirmAccount {
      id
      name
      type
      businessType
      uniqueLink
      createAt
      updateAt
      deleteAt
    }
  }
}
    `;

/**
 * __useGetBusinessInformationQuery__
 *
 * To run a query within a React component, call `useGetBusinessInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessInformationQuery, GetBusinessInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessInformationQuery, GetBusinessInformationQueryVariables>(GetBusinessInformationDocument, options);
      }
export function useGetBusinessInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessInformationQuery, GetBusinessInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessInformationQuery, GetBusinessInformationQueryVariables>(GetBusinessInformationDocument, options);
        }
export type GetBusinessInformationQueryHookResult = ReturnType<typeof useGetBusinessInformationQuery>;
export type GetBusinessInformationLazyQueryHookResult = ReturnType<typeof useGetBusinessInformationLazyQuery>;
export type GetBusinessInformationQueryResult = Apollo.QueryResult<GetBusinessInformationQuery, GetBusinessInformationQueryVariables>;
export const GetFirmNotificationsDocument = gql`
    query GetFirmNotifications {
  getFirmNotifications {
    TEAM {
      id
      firmAccountId
      notificationId
      active
      Notifications {
        name
        description
        type
      }
    }
    CLIENT {
      id
      firmAccountId
      notificationId
      active
      Notifications {
        name
        description
        type
      }
    }
    REMINDERS {
      id
      firmAccountId
      notificationId
      active
      Notifications {
        name
        description
        type
      }
      FirmNotificationReminder {
        id
        frequency
        maxReminders
      }
    }
  }
}
    `;

/**
 * __useGetFirmNotificationsQuery__
 *
 * To run a query within a React component, call `useGetFirmNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFirmNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetFirmNotificationsQuery, GetFirmNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmNotificationsQuery, GetFirmNotificationsQueryVariables>(GetFirmNotificationsDocument, options);
      }
export function useGetFirmNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmNotificationsQuery, GetFirmNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmNotificationsQuery, GetFirmNotificationsQueryVariables>(GetFirmNotificationsDocument, options);
        }
export type GetFirmNotificationsQueryHookResult = ReturnType<typeof useGetFirmNotificationsQuery>;
export type GetFirmNotificationsLazyQueryHookResult = ReturnType<typeof useGetFirmNotificationsLazyQuery>;
export type GetFirmNotificationsQueryResult = Apollo.QueryResult<GetFirmNotificationsQuery, GetFirmNotificationsQueryVariables>;
export const GetClientsDocument = gql`
    query GetClients($skip: Float, $take: Float, $searchTerm: String, $orderBy: UserFirmAccountOrderByInput) {
  Clients(skip: $skip, take: $take, searchTerm: $searchTerm, orderBy: $orderBy) {
    pagination {
      total
    }
    data {
      Entity {
        id
        ownerId
        Users {
          id
          email
          languageId
          invitationEmailSent
          hasPassword
          UserInformation {
            id
            userId
            firstName
            lastName
            birthday
            notes
            Phones {
              id
              createAt
              updateAt
              userInformationId
              value
              type
            }
            Address {
              id
            }
          }
          ReferredByUser {
            email
            UserInformation {
              firstName
              lastName
            }
          }
        }
        TaxYear {
          id
          year
          createAt
          TaxYearInterview {
            id
            taxYearId
            preparedId
            reviewedId
            progressStatusId
            notes
            assignedAt
            completedAt
            reviewStatus
            preparerAcceptedAt
            createAt
            updateAt
            JobTracking {
              id
              expectedCompletion
              paymentsCompletedAt
              approvalsCompletedAt
              interviewCompletedAt
              filesCompletedAt
            }
            Tasks {
              id
              taskType
              createAt
              updateAt
              taxYearId
              deletedAt
              completedAt
            }
            PreparedUser {
              id
              email
              UserInformation {
                id
                userId
                birthday
                firstName
                lastName
                createAt
                updateAt
              }
            }
            ReviewedUser {
              id
              email
              UserInformation {
                id
                userId
                birthday
                firstName
                lastName
                createAt
                updateAt
              }
            }
            Interviews {
              id
              firmAccountId
              name
              isTemplate
              isLive
              drakePackage
              createAt
              updateAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetDeletedClientsDocument = gql`
    query GetDeletedClients($skip: Float, $take: Float, $orderBy: UserFirmAccountOrderByInput) {
  DeletedClients(skip: $skip, take: $take, orderBy: $orderBy) {
    pagination {
      total
    }
    data {
      deleteAt
      id
      Entity {
        id
        ownerId
        Users {
          id
          email
          UserInformation {
            id
            userId
            firstName
            lastName
            Phones {
              id
              value
              type
            }
          }
        }
        TaxYear {
          id
          year
          TaxYearInterview {
            id
            taxYearId
            Interviews {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDeletedClientsQuery__
 *
 * To run a query within a React component, call `useGetDeletedClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeletedClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeletedClientsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetDeletedClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetDeletedClientsQuery, GetDeletedClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeletedClientsQuery, GetDeletedClientsQueryVariables>(GetDeletedClientsDocument, options);
      }
export function useGetDeletedClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeletedClientsQuery, GetDeletedClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeletedClientsQuery, GetDeletedClientsQueryVariables>(GetDeletedClientsDocument, options);
        }
export type GetDeletedClientsQueryHookResult = ReturnType<typeof useGetDeletedClientsQuery>;
export type GetDeletedClientsLazyQueryHookResult = ReturnType<typeof useGetDeletedClientsLazyQuery>;
export type GetDeletedClientsQueryResult = Apollo.QueryResult<GetDeletedClientsQuery, GetDeletedClientsQueryVariables>;
export const GetClientsByProgressStatusIdDocument = gql`
    query GetClientsByProgressStatusId($progressStatusId: String!, $skip: Float, $take: Float, $searchTerm: String, $orderBy: TaxYearInterviewOrderByInput) {
  ClientsByTaxYearStatus(
    progressStatusId: $progressStatusId
    skip: $skip
    take: $take
    searchTerm: $searchTerm
    orderBy: $orderBy
  ) {
    data {
      ...ClientsByStatus
    }
    pagination {
      total
    }
  }
}
    ${ClientsByStatusFragmentDoc}`;

/**
 * __useGetClientsByProgressStatusIdQuery__
 *
 * To run a query within a React component, call `useGetClientsByProgressStatusIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByProgressStatusIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByProgressStatusIdQuery({
 *   variables: {
 *      progressStatusId: // value for 'progressStatusId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      searchTerm: // value for 'searchTerm'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetClientsByProgressStatusIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByProgressStatusIdQuery, GetClientsByProgressStatusIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByProgressStatusIdQuery, GetClientsByProgressStatusIdQueryVariables>(GetClientsByProgressStatusIdDocument, options);
      }
export function useGetClientsByProgressStatusIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByProgressStatusIdQuery, GetClientsByProgressStatusIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByProgressStatusIdQuery, GetClientsByProgressStatusIdQueryVariables>(GetClientsByProgressStatusIdDocument, options);
        }
export type GetClientsByProgressStatusIdQueryHookResult = ReturnType<typeof useGetClientsByProgressStatusIdQuery>;
export type GetClientsByProgressStatusIdLazyQueryHookResult = ReturnType<typeof useGetClientsByProgressStatusIdLazyQuery>;
export type GetClientsByProgressStatusIdQueryResult = Apollo.QueryResult<GetClientsByProgressStatusIdQuery, GetClientsByProgressStatusIdQueryVariables>;
export const GetOtpBooleanDocument = gql`
    query GetOTPBoolean {
  GetOTPBoolean {
    success
    apiToken
  }
}
    `;

/**
 * __useGetOtpBooleanQuery__
 *
 * To run a query within a React component, call `useGetOtpBooleanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtpBooleanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtpBooleanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOtpBooleanQuery(baseOptions?: Apollo.QueryHookOptions<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>(GetOtpBooleanDocument, options);
      }
export function useGetOtpBooleanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>(GetOtpBooleanDocument, options);
        }
export type GetOtpBooleanQueryHookResult = ReturnType<typeof useGetOtpBooleanQuery>;
export type GetOtpBooleanLazyQueryHookResult = ReturnType<typeof useGetOtpBooleanLazyQuery>;
export type GetOtpBooleanQueryResult = Apollo.QueryResult<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>;
export const CustomDomainUserDocument = gql`
    query CustomDomainUser {
  CustomDomainUser {
    id
    name
    certificateArn
    cloudfrontIdId
    status
    firmAccountId
  }
}
    `;

/**
 * __useCustomDomainUserQuery__
 *
 * To run a query within a React component, call `useCustomDomainUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDomainUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDomainUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomDomainUserQuery(baseOptions?: Apollo.QueryHookOptions<CustomDomainUserQuery, CustomDomainUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDomainUserQuery, CustomDomainUserQueryVariables>(CustomDomainUserDocument, options);
      }
export function useCustomDomainUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDomainUserQuery, CustomDomainUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDomainUserQuery, CustomDomainUserQueryVariables>(CustomDomainUserDocument, options);
        }
export type CustomDomainUserQueryHookResult = ReturnType<typeof useCustomDomainUserQuery>;
export type CustomDomainUserLazyQueryHookResult = ReturnType<typeof useCustomDomainUserLazyQuery>;
export type CustomDomainUserQueryResult = Apollo.QueryResult<CustomDomainUserQuery, CustomDomainUserQueryVariables>;
export const CurrentStripeInformationDocument = gql`
    query CurrentStripeInformation {
  CurrentStripeInformation {
    id
    customerId
    subscriptionId
    firmAccountId
    plan
    connectAccountId
    finishedOnboarding
  }
}
    `;

/**
 * __useCurrentStripeInformationQuery__
 *
 * To run a query within a React component, call `useCurrentStripeInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentStripeInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentStripeInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentStripeInformationQuery(baseOptions?: Apollo.QueryHookOptions<CurrentStripeInformationQuery, CurrentStripeInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentStripeInformationQuery, CurrentStripeInformationQueryVariables>(CurrentStripeInformationDocument, options);
      }
export function useCurrentStripeInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentStripeInformationQuery, CurrentStripeInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentStripeInformationQuery, CurrentStripeInformationQueryVariables>(CurrentStripeInformationDocument, options);
        }
export type CurrentStripeInformationQueryHookResult = ReturnType<typeof useCurrentStripeInformationQuery>;
export type CurrentStripeInformationLazyQueryHookResult = ReturnType<typeof useCurrentStripeInformationLazyQuery>;
export type CurrentStripeInformationQueryResult = Apollo.QueryResult<CurrentStripeInformationQuery, CurrentStripeInformationQueryVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices {
  GetInvoices {
    id
    created
    number
    amountDue
    paid
    pdf
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetPaymentIntentsDocument = gql`
    query GetPaymentIntents {
  GetPaymentIntents {
    id
    created
    amount
    amount_capturable
    amount_received
    receipt_email
    description
    refunds {
      id
      amount
      created
      status
    }
  }
}
    `;

/**
 * __useGetPaymentIntentsQuery__
 *
 * To run a query within a React component, call `useGetPaymentIntentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentIntentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentIntentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentIntentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>(GetPaymentIntentsDocument, options);
      }
export function useGetPaymentIntentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>(GetPaymentIntentsDocument, options);
        }
export type GetPaymentIntentsQueryHookResult = ReturnType<typeof useGetPaymentIntentsQuery>;
export type GetPaymentIntentsLazyQueryHookResult = ReturnType<typeof useGetPaymentIntentsLazyQuery>;
export type GetPaymentIntentsQueryResult = Apollo.QueryResult<GetPaymentIntentsQuery, GetPaymentIntentsQueryVariables>;
export const GetUpcomingInvoiceDocument = gql`
    query GetUpcomingInvoice {
  GetUpcomingInvoice {
    created
    number
    amountDue
    discount
    startingBalance
    endingBalance
    nextPayment
    periodStart
    periodEnd
  }
}
    `;

/**
 * __useGetUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useGetUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingInvoiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUpcomingInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>(GetUpcomingInvoiceDocument, options);
      }
export function useGetUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>(GetUpcomingInvoiceDocument, options);
        }
export type GetUpcomingInvoiceQueryHookResult = ReturnType<typeof useGetUpcomingInvoiceQuery>;
export type GetUpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useGetUpcomingInvoiceLazyQuery>;
export type GetUpcomingInvoiceQueryResult = Apollo.QueryResult<GetUpcomingInvoiceQuery, GetUpcomingInvoiceQueryVariables>;
export const GetNylasAccountsDocument = gql`
    query getNylasAccounts {
  getNylasAccounts {
    accountId
    provider
    syncState
    emailAddress
    accessToken
  }
}
    `;

/**
 * __useGetNylasAccountsQuery__
 *
 * To run a query within a React component, call `useGetNylasAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNylasAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNylasAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNylasAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetNylasAccountsQuery, GetNylasAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNylasAccountsQuery, GetNylasAccountsQueryVariables>(GetNylasAccountsDocument, options);
      }
export function useGetNylasAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNylasAccountsQuery, GetNylasAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNylasAccountsQuery, GetNylasAccountsQueryVariables>(GetNylasAccountsDocument, options);
        }
export type GetNylasAccountsQueryHookResult = ReturnType<typeof useGetNylasAccountsQuery>;
export type GetNylasAccountsLazyQueryHookResult = ReturnType<typeof useGetNylasAccountsLazyQuery>;
export type GetNylasAccountsQueryResult = Apollo.QueryResult<GetNylasAccountsQuery, GetNylasAccountsQueryVariables>;
export const IsActiveFirmDocument = gql`
    query isActiveFirm {
  isActiveFirm
}
    `;

/**
 * __useIsActiveFirmQuery__
 *
 * To run a query within a React component, call `useIsActiveFirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsActiveFirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsActiveFirmQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsActiveFirmQuery(baseOptions?: Apollo.QueryHookOptions<IsActiveFirmQuery, IsActiveFirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsActiveFirmQuery, IsActiveFirmQueryVariables>(IsActiveFirmDocument, options);
      }
export function useIsActiveFirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsActiveFirmQuery, IsActiveFirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsActiveFirmQuery, IsActiveFirmQueryVariables>(IsActiveFirmDocument, options);
        }
export type IsActiveFirmQueryHookResult = ReturnType<typeof useIsActiveFirmQuery>;
export type IsActiveFirmLazyQueryHookResult = ReturnType<typeof useIsActiveFirmLazyQuery>;
export type IsActiveFirmQueryResult = Apollo.QueryResult<IsActiveFirmQuery, IsActiveFirmQueryVariables>;
export const GetFirmSettingsDocument = gql`
    query getFirmSettings($category: String!) {
  getFirmSettings(category: $category) {
    id
    name
    description
    type
    category
    value {
      ... on BooleanValue {
        boolValue
      }
      ... on NumberValue {
        numValue
      }
      ... on DateValue {
        dateValue
      }
      ... on StringValue {
        strValue
      }
    }
  }
}
    `;

/**
 * __useGetFirmSettingsQuery__
 *
 * To run a query within a React component, call `useGetFirmSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmSettingsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetFirmSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetFirmSettingsQuery, GetFirmSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmSettingsQuery, GetFirmSettingsQueryVariables>(GetFirmSettingsDocument, options);
      }
export function useGetFirmSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmSettingsQuery, GetFirmSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmSettingsQuery, GetFirmSettingsQueryVariables>(GetFirmSettingsDocument, options);
        }
export type GetFirmSettingsQueryHookResult = ReturnType<typeof useGetFirmSettingsQuery>;
export type GetFirmSettingsLazyQueryHookResult = ReturnType<typeof useGetFirmSettingsLazyQuery>;
export type GetFirmSettingsQueryResult = Apollo.QueryResult<GetFirmSettingsQuery, GetFirmSettingsQueryVariables>;
export const GetFirmSettingDocument = gql`
    query getFirmSetting($name: String!) {
  getFirmSetting(name: $name) {
    id
    name
    description
    type
    category
    value {
      ... on BooleanValue {
        boolValue
      }
      ... on NumberValue {
        numValue
      }
      ... on DateValue {
        dateValue
      }
      ... on StringValue {
        strValue
      }
    }
  }
}
    `;

/**
 * __useGetFirmSettingQuery__
 *
 * To run a query within a React component, call `useGetFirmSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmSettingQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFirmSettingQuery(baseOptions: Apollo.QueryHookOptions<GetFirmSettingQuery, GetFirmSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmSettingQuery, GetFirmSettingQueryVariables>(GetFirmSettingDocument, options);
      }
export function useGetFirmSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmSettingQuery, GetFirmSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmSettingQuery, GetFirmSettingQueryVariables>(GetFirmSettingDocument, options);
        }
export type GetFirmSettingQueryHookResult = ReturnType<typeof useGetFirmSettingQuery>;
export type GetFirmSettingLazyQueryHookResult = ReturnType<typeof useGetFirmSettingLazyQuery>;
export type GetFirmSettingQueryResult = Apollo.QueryResult<GetFirmSettingQuery, GetFirmSettingQueryVariables>;
export const GetClientsBasicInfoDocument = gql`
    query getClientsBasicInfo {
  getClientsBasicInfo {
    id
    Entity {
      id
      Users {
        id
        email
        UserInformation {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientsBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetClientsBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientsBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsBasicInfoQuery, GetClientsBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsBasicInfoQuery, GetClientsBasicInfoQueryVariables>(GetClientsBasicInfoDocument, options);
      }
export function useGetClientsBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsBasicInfoQuery, GetClientsBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsBasicInfoQuery, GetClientsBasicInfoQueryVariables>(GetClientsBasicInfoDocument, options);
        }
export type GetClientsBasicInfoQueryHookResult = ReturnType<typeof useGetClientsBasicInfoQuery>;
export type GetClientsBasicInfoLazyQueryHookResult = ReturnType<typeof useGetClientsBasicInfoLazyQuery>;
export type GetClientsBasicInfoQueryResult = Apollo.QueryResult<GetClientsBasicInfoQuery, GetClientsBasicInfoQueryVariables>;
export const namedOperations = {
  Query: {
    GetCustomDomainUser: 'GetCustomDomainUser',
    CustomDomainCertificateStatus: 'CustomDomainCertificateStatus',
    CustomDomainCnameStatus: 'CustomDomainCnameStatus',
    IsDomainLive: 'IsDomainLive',
    GetCloudFrontDistributionByCertificateArn: 'GetCloudFrontDistributionByCertificateArn',
    GetCustomLayouts: 'GetCustomLayouts',
    GetUserInformation: 'GetUserInformation',
    GetSubscription: 'GetSubscription',
    GetAllPlans: 'GetAllPlans',
    GetPlansByProductId: 'GetPlansByProductId',
    GetPlan: 'GetPlan',
    GetUserUniqueLink: 'GetUserUniqueLink',
    GetFirmUniqueLink: 'GetFirmUniqueLink',
    GetProgressStatuses: 'GetProgressStatuses',
    GetUserFirmAccountByFirmAccount: 'GetUserFirmAccountByFirmAccount',
    GetUserById: 'GetUserById',
    GetRoles: 'GetRoles',
    GetUserFirmAccountByFirmAccountAndFilter: 'GetUserFirmAccountByFirmAccountAndFilter',
    GenerateOTP: 'GenerateOTP',
    FirmAccountById: 'FirmAccountById',
    GetBusinessInformation: 'GetBusinessInformation',
    GetFirmNotifications: 'GetFirmNotifications',
    GetClients: 'GetClients',
    GetDeletedClients: 'GetDeletedClients',
    GetClientsByProgressStatusId: 'GetClientsByProgressStatusId',
    GetOTPBoolean: 'GetOTPBoolean',
    CustomDomainUser: 'CustomDomainUser',
    CurrentStripeInformation: 'CurrentStripeInformation',
    GetInvoices: 'GetInvoices',
    GetPaymentIntents: 'GetPaymentIntents',
    GetUpcomingInvoice: 'GetUpcomingInvoice',
    getNylasAccounts: 'getNylasAccounts',
    isActiveFirm: 'isActiveFirm',
    getFirmSettings: 'getFirmSettings',
    getFirmSetting: 'getFirmSetting',
    getClientsBasicInfo: 'getClientsBasicInfo'
  },
  Fragment: {
    StripeMetaData: 'StripeMetaData',
    Invoices: 'Invoices',
    Payments: 'Payments',
    SignatureField: 'SignatureField',
    Signature: 'Signature',
    File: 'File',
    KBAFields: 'KBAFields',
    KBA: 'KBA',
    FileApproval: 'FileApproval',
    FileRequest: 'FileRequest',
    LanguageEntity: 'LanguageEntity',
    ClientsByStatus: 'ClientsByStatus'
  }
}